import { MAP_TYPES } from "@deck.gl/carto";
import { CONNECTION } from "../config.js";
const VISITORS_DESTINATION_SOURCE_ID = "visitorsDestinationSource";

const source = {
  id: VISITORS_DESTINATION_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: CONNECTION.connection,
  data: `SELECT geo_id, geom FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table}`,
};

export default source;
